<template>
  <div class="project-orders">
    <!-- Order Form Section -->
    <div v-if="showOrderForm && editingOrder" class="order-form-section mb-4">
      <div class="card">
        <div class="card-header d-flex justify-content-between align-items-center">
          <h5 class="mb-0">
            {{ editingOrder.number === '_new' ? $t('order_create') : $t('edit_order') }}
            <span v-if="editingOrder.number !== '_new'">
              #{{ editingOrder.number.toString().padStart(4, '0') }}
            </span>
          </h5>
          <button class="btn btn-sm btn-outline-secondary" @click="closeOrderForm">
            <i class="fa fa-times"></i>
          </button>
        </div>
        <div class="card-body">
          <OrderForm
            :order="editingOrder"
            :projectContext="project"
            :showCancelButton="true"
            @save="handleSaveOrder"
            @cancel="closeOrderForm"
          />
        </div>
      </div>
    </div>

    <!-- Orders Table Section -->
    <OrdersTable
      :projectFilter="project.id"
      :tableStatePrefix="`project-${project.number}-orders`"
      :showProjectColumn="false"
      :createOrderRoute="{ name: 'OrderCreatePage', query: { projectId: project.id } }"
      @edit-order="handleEditOrder"
      @create-order="createNewOrder"
    />
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import OrdersTable from '@/components/Orders/OrdersTable.vue';
import OrderForm from '@/components/Orders/OrderForm.vue';

export default {
  name: 'ProjectOrders',
  components: {
    OrdersTable,
    OrderForm,
  },
  props: {
    project: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },
  data() {
    return {
      showOrderForm: true,
      editingOrder: null,
    };
  },
  computed: {
    ...mapGetters(['isLoading', 'getOrderByNumber']),
  },
  methods: {
    ...mapActions(['initOrder', 'createOrder', 'updateOrder', 'fetchOrderByNumber']),

    async handleEditOrder(order) {
      await this.fetchOrderByNumber(order.number);
      this.editingOrder = this.getOrderByNumber(order.number);
      this.showOrderForm = true;
    },

    async handleSaveOrder(order) {
      try {
        if (order.number === '_new') {
          await this.createOrder(order);
        } else {
          await this.updateOrder(order);
        }
        this.closeOrderForm();
      } catch (error) {
        console.error('Error saving order:', error);
      }
    },

    closeOrderForm() {
      this.showOrderForm = false;
      this.editingOrder = null;
    },

    createNewOrder() {
      this.initOrder();
      const newOrder = this.getOrderByNumber('_new');
      if (newOrder) {
        this.editingOrder = { ...newOrder };
        this.showOrderForm = true;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.order-form-section {
  .card {
    border: 1px solid #dee2e6;
    border-radius: 0.375rem;

    .card-header {
      background-color: #f8f9fa;
      border-bottom: 1px solid #dee2e6;
      padding: 0.75rem 1rem;

      h5 {
        color: #495057;
        font-weight: 600;
      }
    }

    .card-body {
      padding: 1rem;
    }
  }
}

.project-orders {
  .btn-outline-secondary {
    border-color: #6c757d;
    color: #6c757d;

    &:hover {
      background-color: #6c757d;
      border-color: #6c757d;
      color: white;
    }
  }
}
</style>
